<div *ngIf="isCard1">
  <div class=" card-container">
    <div class="pt-2"><h6>Configure Google Authenticator</h6></div>
    <div class="card-body d-flex flex-column  align-items-center">
      <ul>
        <li>Install Google Authenticator for
          <a href="https://apps.apple.com/us/app/google-authenticator/id388497605">iOS</a>
          or <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2">Android</a>.
        </li>
        <li>In the authenticator app, select the <img alt="" src="{{googleAdd}}" width="30px"> icon.</li>
        <li>Select "Scan a barcode (or QR code)" and use the phone's camera to scan this barcode.</li>
      </ul>
    </div>
  </div>
  <div class="display-right">
    <button (click)="showCard2()" class="right-button rounded-button">
      <i class="fa fa-angle-right"></i>
    </button>
  </div>
</div>

<div *ngIf="isCard2">
  <div class="card-container">
    <div class="pt-2"><h6> Scan the QR Code</h6></div>
    <div class=" d-flex flex-column align-items-center">
      <div class="d-flex justify-content-center">
        <img [src]="getQrCodeUrl()" alt="" class="justify-content-center" height="225px" width="225px"/>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div>
      <button (click)="showCard1()" class="left-button rounded-button">
        <i class="fa fa-angle-left"></i>
      </button>
    </div>
    <div>
      <button (click)="showCard3()" class="right-button rounded-button">
        <i class="fa fa-angle-right"></i>
      </button>
    </div>
  </div>
</div>

<div *ngIf="isCard3">
  <div class="card-container ">
    <div class="pt-2"><h6> Verify Code</h6></div>
    <div class="d-flex flex-column align-items-center mt-3">
      <p class="card-text text-center">To confirm, please verify the authentication code:</p>
      <form class="mb-5 mt-2">
        <div style="width: 75%; margin: auto;">
          <code-input (codeChanged)="verifyCode($event)"
                      (codeCompleted)="verifyCode($event)"
                      [codeLength]="6"
                      [isCodeHidden]="false"
                      id="googleAuthenticatorCode">
          </code-input>
        </div>
        <p *ngIf="invalidAuthCode" class="mt-2 text-xs text-center" style="color: rgb(220 38 38);">
          Invalid authentication code.
        </p>
      </form>
    </div>
  </div>
  <div class="pull-right w-auto">
    <button (click)="logout()" class="btn btn-danger" type="button">
      <i aria-hidden="true" class="fa fa-sign-out"></i>
      log out
    </button>
  </div>
  <div class="d-flex justify-content-between">
    <div>
      <button (click)="showCard2()" class="left-button rounded-button">
        <i class="fa fa-angle-left"></i>
      </button>
    </div>
  </div>
</div>
